
import * as actions from '../../constants/action-types';

export const downloadAppointmentRequestFile = (payload, targetFileName) => ({
    type: actions.DOWNLOAD_APPOINTMENT_FILE,
    payload,
    targetFileName,
});
